export const MULTI_PANEL_CELL_TEST_ID = {
  cell: 'multi-panel-cell',
};
